import {initAuthBooking} from "./header/auth-booking";
import {initHotelSearchScripts} from "./sections/hotel-search";
import {initHotelSingleSlider} from "./sections/hotel-single/slider";
import {initHotelSingleMisc} from "./sections/hotel-single/misc";
import {initHotelSingleBooking} from "./sections/hotel-single/booking";
import {initHotelSingleLoader} from "./sections/hotel-single/loader";
import {initDashboard} from "./sections/dashboard";
import {initHotelBookingPage} from "./pages/hotel-booking";

(function () {
    async function initApp() {
        initAuthBooking();
        initHotelSingleLoader();
        initHotelSingleSlider();
        initHotelSingleMisc();
        initHotelSingleBooking();
        initDashboard();
        initHotelBookingPage();
        await initHotelSearchScripts();
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initApp);
    } else {
        initApp();
    }
})();
